// extracted by mini-css-extract-plugin
export default {"products":"BB-z","card":"CB-z","oosMessaging":"DB-z"};